import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchOverviewStatusDone = (_, { payload }) => {
    return payload
}

const initialState = {
  closedCount: 0,
  days30PlusCount: 0,
  days30_60Count: 0,
  days60PlusCount: 0,
  declinedCount: 0,
  enRouteCount: 0,
  inProgressCount: 0,
  onHoldCount: 0,
  resolvedCount: 0,
  scheduledCount: 0,
  submittedCount: 0
};

export default createReducer(initialState, {
  [TYPES.FETCH_OVER_VIEW_STATUS_DAYS_DONE]: fetchOverviewStatusDone
});
